import {FC} from "react";
import {useTranslation} from "react-i18next";
import {useFlags} from "launchdarkly-react-client-sdk";
import {
  SimpleTable,
  TableBody,
  TableRow,
  TableCell
} from "@interstate/components/SimpleTable";
import {OrganizationInformationInput} from "@common-core/coat-operational-hierarchy-appsync-model";
import {TabRow} from "../../../../../tab-content";
import {features} from "../../../../../features";

export interface BusinessInformationProps {
  organizationInformation: OrganizationInformationInput;
  tenantName?: string;
}

export const BusinessInformationRow: FC<BusinessInformationProps> = ({
  organizationInformation,
  tenantName
}) => {
  const {t} = useTranslation();
  const flags = useFlags();
  return (
    <TabRow
      name={"business-information"}
      header={<h4>{t("entity-detail.dealer.business-information")}</h4>}>
      <SimpleTable
        id={"business-information-table"}
        data-testid={"business-information-table"}
        dataDensity={"small"}
        background={"white"}
        className={"business-information-table"}
        bordered={false}
        hover={false}
        striped={false}>
        <TableBody>
          <TableRow>
            <TableCell className={"information-field"}>
              {t("entity-detail.dealer.legal-name")}
            </TableCell>
            <TableCell
              id={"dealer-information-legal-name"}
              className={"information-value"}>
              {organizationInformation.legalName}
            </TableCell>
          </TableRow>
          {flags[features.dev.createOrg.createWithTenant] && tenantName && (
            <TableRow>
              <TableCell className={"information-field"}>
                {t("entity-detail.dealer.tenant-name")}
              </TableCell>
              <TableCell
                id={"dealer-information-tenant-name"}
                className={"information-value"}>
                {tenantName}
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className={"information-field"}>
              {t("entity-detail.dealer.dba-name")}
            </TableCell>
            <TableCell
              id={"dealer-information-dba-name"}
              className={"information-value"}>
              {organizationInformation.dbaName}
            </TableCell>
          </TableRow>
        </TableBody>
      </SimpleTable>
    </TabRow>
  );
};
